import { Features } from '../features/features';
import { ConfirmationComponent } from '../shared/components/confirmation/confirmation.component';
import { Routes } from '@angular/router';
import { authenticatedGuard } from '../core/guards/authenticated/authenticated.guard';

export const ROUTES: Routes = [
  {
    path: '',
    redirectTo: 'quotes',
    pathMatch: 'full',
  },
  {
    path: 'login',
    redirectTo: 'auth/login',
    pathMatch: 'full',
  },
  {
    path: Features.QUOTES,
    loadChildren: () =>
      import('../features/quotes/quotes.module').then((m) => m.QuotesModule),
    canActivateChild: [authenticatedGuard],
  },
  {
    path: Features.AUTH,
    loadChildren: () =>
      import('../features/auth/auth.module').then((m) => m.AuthModule),
  },
  {
    path: Features.SETTINGS,
    loadChildren: () =>
      import('../features/settings/settings.module').then(
        (m) => m.SettingsModule,
      ),
    canActivateChild: [authenticatedGuard],
  },
  {
    path: Features.BILLING,
    loadChildren: () => import('../features/billing/billing.routes'),
    canActivateChild: [authenticatedGuard],
  },
  {
    path: Features.COMMISSIONS,
    loadChildren: () =>
      import('../features/commissions/commissions.module').then(
        (m) => m.CommissionsModule,
      ),
    canActivateChild: [authenticatedGuard],
  },
  {
    path: Features.SIGNUP,
    loadChildren: () =>
      import('../features/signup/signup.module').then((m) => m.SignupModule),
  },
  {
    path: Features.EXCHANGE,
    loadChildren: () =>
      import('../features/exchange/exchange.module').then(
        (m) => m.ExchangeModule,
      ),
    canActivateChild: [authenticatedGuard],
  },
  {
    path: Features.REPORTS,
    loadChildren: () =>
      import('../features/reports/reports.module').then((m) => m.ReportsModule),
    canActivateChild: [authenticatedGuard],
  },
  {
    path: Features.APPETITE_SEARCH,
    loadChildren: () =>
      import('../features/appetite-search/appetite-search.module').then(
        (m) => m.AppetiteSearchModule,
      ),
    canActivateChild: [authenticatedGuard],
  },
  {
    path: Features.CONFIRM,
    component: ConfirmationComponent,
    title: 'Confirmation',
  },
  {
    path: 'reports',
    redirectTo: `${Features.REPORTS}`,
  },
  {
    path: 'application_forms/:id',
    redirectTo: 'quotes/form/:id',
  },
  {
    path: 'application_forms/:id/latest',
    redirectTo: 'quotes/form/:id',
  },
  {
    path: '**',
    redirectTo: 'auth',
  },
];
